import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';

@Component({
    selector: 'app-explanation',
    template: `
      <span *ngIf="label" (mouseenter)="onHoverIn($event)" (mouseleave)="onHoverOut($event)">{{label}}</span>
      <mat-icon class="explanation" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="toggle()" (mouseenter)="onHoverIn($event)"
                (mouseleave)="onHoverOut($event)">{{icon}}
      </mat-icon>
      <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="trigger"
              [cdkConnectedOverlayOpen]="isOpen">
          <div class="mdc-tooltip__surface mat-tooltip-custom"
               (mouseenter)="onHoverInOverlay($event)"
               (mouseleave)="onHoverOutOverlay($event)">
              <ng-content></ng-content>
          </div>
      </ng-template>
  `,
    styles: [],
    standalone: true,
    imports: [NgIf, MatIcon, CdkOverlayOrigin, CdkConnectedOverlay]
})
export class ExplanationComponent {

  @Input() icon = 'info_outline';
  @Input() label = '';
  @Input() hideDelay: number = 100;

  isOpen: boolean;
  isOverlayHovered: boolean;

  private showTimeOutId: ReturnType<typeof setTimeout>;

  onHoverIn($event: FocusEvent) {
    console.log('onHoverIn', $event);
    this.isOpen = true;
    if (this.showTimeOutId) {
      clearTimeout(this.showTimeOutId);
    }
  }

  onHoverOut($event: FocusEvent) {
    console.log('onHoverOut', $event);
    if (this.hideDelay > 0) {
      if (this.showTimeOutId) {
        clearTimeout(this.showTimeOutId);
      }

      this.showTimeOutId = setTimeout(() => {
        this.isOpen = false;
      }, this.hideDelay)

    } else {
      this.isOpen = false;
    }
  }

  onHoverInOverlay($event: FocusEvent) {
    console.log('onHoverInOverlay', $event);
    this.isOverlayHovered = true;
    if (this.showTimeOutId) {
      clearTimeout(this.showTimeOutId);
    }
  }

  onHoverOutOverlay($event: FocusEvent) {
    console.log('onHoverOutOverlay', $event);
    this.isOverlayHovered = false;
    if (this.hideDelay > 0) {
      if (this.showTimeOutId) {
        clearTimeout(this.showTimeOutId);
      }

      this.showTimeOutId = setTimeout(() => {
        this.isOpen = false;
      }, this.hideDelay)

    } else {
      this.isOpen = false;
    }
  }

  toggle() {
    // this.isOpen = !this.isOpen;
  }
}
